var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrightenImg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 148,
    viewBox: "0 0 147 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.3158 6.50303e-06C66.7929 6.50303e-06 62.3158 4.47716 62.3158 10L62.3158 53.614C62.3158 59.1369 57.8386 63.614 52.3158 63.614L10 63.614C4.47715 63.614 0 68.0912 0 73.614L6.50303e-06 138C6.98585e-06 143.523 4.47716 148 10 148H74.386C79.9088 148 84.386 143.523 84.386 138L84.386 94.386C84.386 88.8631 88.8631 84.386 94.386 84.386L136.702 84.386C142.225 84.386 146.702 79.9088 146.702 74.386V10C146.702 4.47715 142.225 -4.82822e-07 136.702 0L72.3158 6.50303e-06Z",
    fill: "#FEBF88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrightenImg3);
export default __webpack_public_path__ + "static/media/brighten-img-3.ae84754b4276da7b688195317cde86a6.svg";
export { ForwardRef as ReactComponent };